/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 **/
class OAuthService {
  getHeaders() {
    const token = JSON.parse(sessionStorage.getItem('loginData') as string)
    const headers = {
      authorization: `Bearer ${token.access_token}`,
      'Content-Type': 'application/json'
    }
    return headers
  }
}

export default OAuthService
